#
# List of languages translated in the current locale
#
languages:
    en: { code: "EN", name: "English" }
    fr: { code: "FR", name: "French" }

#
# Diverse actions, typically used in buttons
#
action:
    ok: "Ok"
    apply: "Apply"
    cancel: "Cancel"
    close: "Close"
    edit: "Edit"
    remove: "Remove"
    add: "Add"
    saveAndClose: "Save and Close"
    validate: "Validate"

#
# Each unit returned by the API should be translated here
#
unit:
    "-":            "-"
    "sec":          "seconds"
    "min":          "minutes"
    "h":            "hours"
    "days":         "days"
    "d":            "days"
    "weeks":        "weeks"
    "y":            "years"
    "kg":           "kg"
    "mg":           "mg"
    "ml/min":       "ml/min"
    "ug/l":         "µg/l"
    "mg/l":         "mg/l"
    "umol/l":       "µmol/l"

#
# Messages displayed when a form field is invalid
#
validationMessage:
    required: "This field is required"
    min: "The value is too small"
    max: "The value is too big"

#
# Various messages for some parts of the app
#
general:
    noDrugSelected: "select a drug..."
    areYouSureToLeave: "Are you sure you want to leave? You will loose your current treatment analysis"


#
# Name of the entries in the main menu. The lang key for each entry must match the route name.
#
menuEntries:
    app:
        patient:        { short: "Pat.",    long: "Patient"     }
        drugs:          { short: "Drugs",   long: "Drugs"       }
        dosages:        { short: "Dos.",    long: "Dosages"     }
        covariates:     { short: "Cov.",    long: "Covariates"  }
        measures:       { short: "Meas.",   long: "Measures"    }
        targets:        { short: "Tar.",    long: "Targets"     }
        adjustments:    { short: "Adj.",    long: "Adjustments" }
        validation:     { short: "Val.",    long: "Validation"  }
        reports:        { short: "Rep.",    long: "Reports"     }


#
# Lang strings for each page of the application
#

patient:
    form:
        requiredInformation: "Patient required information"
        extraInformation: "Patient extra information"
        physicianInCharge: "Physician in charge"
        firstName: "First name"
        lastName: "Last name"
        birthDate: "Birth date"
        gender: "Gender"
        identifier: "Identifier"
        stayNumber: "Stay number"
        address: "Address"
        phone: "Phone"
        city: "City"
        postcode: "Postcode"
        state: "State"
        country: "Country"
        title: "Title"
        affiliation: "Affiliation"
    formData:
        welcome: "Welcome to Tucuxi!"
        graphs: "Graphs of predicted concentrations will be shown here."
        tooltips: "Tooltips can be toggled using CTRL+SHIFT+T.<br>They can be useful to guide you through the software features."

drugs:
    form:
        activeSubstance: "Active substance"
        domain: "Domain"
        study: "Study"

    data:
        drugName: "Drug name:"
        atc: "ATC:"
        domain: "Domain:"
        studyName: "Study:"
        studyDescription: "Study description:"
        studyAuthors: "Study authors:"
        drugModelId: "Drug Model ID:"
        route: "Route:"
        absorption: "Absorption:"
        distribution: "Distribution:"
        elimination: "Elimination:"
        covariates: "Covariates:"

dosages:
    form:
        dosageDefinition: "Dosage definition"
        route: "Route:"
        dose: "Dose:"
        iterations: "Iterations:"
        dosage: "Dosage:"
        interval: "Interval:"
        infusion: "Infusion:"
        isSteady: "At steady state ?"
        lastDose: "Last dose:"
        from: "From:"
        to: "To:"
        steadyState: "steady state"

    table:
        history: "Dosages history"
        from: "From"
        to: "To"
        dose: "Dose"
        interval: "Interval"
        infusion: "Infusion"

covariates:
    form:
        list: "Drug covariates list"
        history: "Patient covariate history"
        name: "Name"
        defaultValue: "Default value"
        currentValue: "Current value"
        value: "Value"
        date: "Date"
        modalTitle: "Covariate parameters"
        disabledNoCovariateSelected: "No covariate selected."
        disabledAge: "The age is automatically calculated based on the birth date."

measures:
    form:
        list: "Measures list"
        id: "ID"
        value: "Value"
        sampleDate: "Sample date"
        arrivalDate: "Arrival date"
        parameters: "Measure parameters"
        sampleIdLabel: "Sample ID:"
        valueLabel: "Value:"
        measuredAtLabel: "Measured:"

targets:
    form:
        list: "Targets list"
        type: "Type"
        min: "Min"
        max: "Max"
        best: "Best"
        parameters: "Target parameters"
        valuesLabel: "Target values:"
        timesLabel: "Times:"
        typeLabel: "Target type:"
        minLabel: "Min:"
        maxLabel: "Max:"
        bestLabel: "Best:"
        micLabel: "MIC:"
        alarmsLabel: "Alarms:"
        enableAlarms: "Enable alarms?"
        inefficacyAlarmLabel: "Inefficacy:"
        toxicityAlarmLabel: "Toxicity:"

adjustments:
    form:
        adjustAt: "Adjust at:"
        loadingDose: "Loading dose?"
        restPeriod: "Rest period?"
        suggestedAdjustments: "Suggested adjustments"
        selectedAdjustment: "Adjustment"
        infoTitle: "Target details"
        infoDescription: "The target details are the following:"
        infoTargetType: "Target type:"
        infoValue: "Value:"
        infoScore: "Score:"
        table:
            type: "Type"
            from: "From"
            to: "To"
            dose: "Dose"
            interval: "Interval"
            duration: "Duration"
            noAdjustments: "No possible adjustments for the selected targets"

validation:
    form:
        parameters: "Parameters"
        validation: "Validation"
        dosage: "Dosage:"
        nextControl: "Next control:"
        expectedness: "Expectedness:"
        suitability: "Suitability:"
        prediction: "Prediction:"
        remonitoring: "Remonitoring:"
        warning: "Warning:"
        parametersTable:
            pkParameters: "Pk Parameters"
            typicalPatient: "Typical patient"
            aPriori: "A priori"
            aPosteriori: "A posteriori"

report:
    form:
        generatePDF: "Generate PDF"


#
# Labels for fields in the chart settings modal
#
chartSettings:
    modalTitle: "Graph settings parameters"
    groupName:
        dosageSettings: "Dosage settings"
        covariateSettings: "Covariate settings"
        measureSettings: "Measeure settings"
        targetSettings: "Target settings"
        adjustmentSettings: "Adjustment settings"
        validationSettings: "Validation settings"
        reportSettings: "Report settings"
        percentiles: "Percentiles"
        generalSettings: "General Settings"

    field:
        showPopulationPrediction: "Typical patient prediction"
        showPopulationPercentiles: "Typical patient percentiles"
        showAprioriPrediction: "A priori prediction"
        showAprioriPercentiles: "A priori percentiles"
        showAposterioriPredictions: "A posteriori prediction"
        showAposterioriPercentiles: "A posteriori percentiles"
        showMeasures: "Measures"
        showTargets: "Targets"
        showPossibleAdjustments: "Suggested adjustments"
        showSelectedAdjustments: "Adjustments"
        showCurrentTime: "Current time"
        showCovariateChange: "Covariate change"
        liveAnnotations: "Live annotations"


#
# Various enum values
#

gender:
    male: "Male"
    female: "Female"
    unknown: "Unknown"

administrationRoute:
    undefined: "Undefined"
    intermuscular: "Intermuscular"
    intravenousBolus: "Intravenous bolus"
    intravenousDrip: "Intravenous drip"
    nasal: "Nasal"
    oral: "Oral"
    rectal: "Rectal"
    subcutaneous: "Subcutaneous"
    sublingual: "Sublingual"
    transdermal: "Transdermal"
    vaginal: "Vaginal"

absorptionModel:
    extra: "Extravascular"
    extra.lag: "Extravascular with lag"
    infusion: "Infusion"
    bolus: "Bolus"

targetType:
    residual: "Residual"
    peak: "Peak"
    mean: "Mean"
    auc: "AUC"
    auc24: "AUC 24h"
    cumulativeAuc: "Cumulative AUC"
    aucDividedByMic: "AUC divided by MIC"
    auc24DividedByMic: "AUC 24h divided by MIC"
    aucOverMic: "AUC over MIC"
    auc24OverMic: "AUC 24h over MIC"
    peakDividedByMic: "Peak divided by MIC"
    timeOverMic: "Time over MIC"
    residualDividedByMic: "Residual divided by MIC"

adjustmentDosageType:
    manual: "Manual"
    suggested: "Suggested"
